<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box no-display">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Leaving Certificate / Transfer Certificate</strong>
                    <v-icon class="ml-2" @click="onload" title="Reload list" dark small color="yellow">mdi-reload</v-icon>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4" class="mt-3">
                    <v-combobox class="no-display" v-model="registration_no" @change="checkHistory" :loading="comp_load"
                        rounded :items="stud_list" label="Select Student" item-text="name" outlined dense
                        prepend-icon="mdi-account-child-circle"></v-combobox>
                </v-col>
            </v-row>
            <div v-if="registration_no != null">
                <!-- collapse table code -->
                <template>
                    <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Account History </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <v-data-table :headers="headers_1" :items="ay_record" class="elevation-1 mytable" dense>
                                    <template v-slot:[`item.status`]="{ item }">
                                        <v-chip :color="getColor(item.status)" dark>
                                            {{ item.status }}
                                        </v-chip>
                                    </template>
                                </v-data-table>
                                <!-- table end -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-expansion-panels class="expapanel no-display" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Academic History </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <!-- table content -->

                                <v-data-table :headers="headers_2" :items="ay_record_div" dense
                                    class="elevation-1 mytable"> </v-data-table>
                                <!-- table end -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </template>

                <!-- radio button end -->
                <v-row justify="center" v-if="ay_record.length != 0">
                    <!-- {{ ay_record }}<br /> -->
                    <div class="fees no-display">
                        <span v-if="account_status" style="color: #4caf50;">Fees Clear </span>
                        <span v-else style="color: #f44336;">Fees Pending</span>
                    </div>
                </v-row>
            </div>
            <!-- end dd -->
        </v-card>

        <template v-if="registration_no != null">
            <template v-if="fetch_gen_toggle=='Generate'">
                <v-row justify="center" class="mt-3">
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="progress" rounded :items="dvt_prog" label="Select Progress" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="conduct" rounded :items="dvt_conduct" label="Select Conduct" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="remark" rounded :items="dvt_remark" label="Select Remark" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="reason" rounded :items="dvt_reason" label="Select Reason" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col cols="12" sm="2" md="2">
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="date_of_generation"
                                    @blur="date = parseDate(date_of_generation)" v-on="on" hint="LC Generation Date"
                                    prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="gen_date" no-title @input="menu1 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="application_date" v-on="on"
                                    hint="Date Of Application" prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="date_of_application" no-title @input="menu2 = false"
                                @change="setToText()"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-menu ref="menu2" v-model="menu3" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="issue_date" v-on="on" hint="Date Of Issue"
                                    prepend-icon="event" persistent-hint></v-text-field>
                            </template>
                            <v-date-picker label="Issue Date" v-model="date_of_issue" no-title
                                @input="menu3 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-text-field dense v-model.trim="cert_no" hint="Enter Certificate No"
                            prepend-icon="mdi-certificate-outline" persistent-hint></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-checkbox color="#0f2027" v-model="mark_inactive"
                        label="Do You Want To Mark Student Inactive After Generating LC.?"></v-checkbox>
                </v-row>
                <v-row justify="center">
                        <v-btn color="info" @click="genLC">Generate LC</v-btn>
                </v-row>
            </template>
            <template v-if="fetch_gen_toggle == 'Fetch'">
                <!-- {{ lc_data }}  -->
            </template>
            <div id="document1" class="printdiv" v-if="lc_data!=null">
                <div class="header">
                    <v-row dense>
                        <div class="row">
                            <div class="col-3">
                                <img :src="org_basic_data.trust_logo" alt="" class="schlImg" />
                            </div>
                            <div class="col-9">
                                <center>
                                    <h4 class="trust-name">
                                        {{org_basic_data.trust_name}}
                                    </h4>
                                </center>
                                <center>
                                    {{org_basic_data.address}}
                                </center>
                                <center>
                                    {{org_basic_data.phone}}
                                </center>
                                <center><strong>UDISE Code:</strong> {{lc_data.udise_no}}</center>
                                <center><strong>ICSE School Code:</strong> {{org_basic_data.school_no}}</center>
                            </div>
                        </div>
                    </v-row>
                </div>

                <div class="lcdata">
                    <v-row>
                        <span style="margin-left: 20px;">Student's Gen. Reg. No:</span>
                        <span class="stud_details">{{lc_data.reg_number}}</span>
                        <span style="margin-left: 750px;">Sr.No:</span>
                        <span>{{lc_data.certificate_no}}</span>
                        <v-col cols="12" sm="12" md="12">
                            <hr class="hr-tag" />
                            <br />
                            <hr class="hr-tag" />
                            <span style="margin-left: 20px;">
                                <b>Student Id:</b>
                                <input type="text" outlined dense v-model="lc_data.gr_number" />
                                <!-- {{ lc_data.gr_number }} -->
                            </span>
                            <span style="margin-left: 500px;">
                                <b>UID Aadhaar No.:</b>
                                <!-- {{ lc_data.aadhar_no }} -->
                                <input type="number" outlined dense v-model="lc_data.aadhar_no" />
                            </span>
                            <hr class="hr-tag" />
                            <div class="row">
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Name Of Pupil in Full:</b><b>(Name) </b>
                                        <div style="width: 60%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{lc_data.first_name}} -->
                                            <input type="text" outlined dense v-model="lc_data.first_name" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>(Father's Name):</b>
                                        <div style="width: 76%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{lc_data.middle_name}} -->
                                            <input type="text" outlined dense v-model="lc_data.middle_name" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 160px;">
                                        <b>(Surname)</b>
                                        <div style="width: 90.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{lc_data.last_name}} -->
                                            <input type="text" outlined dense v-model="lc_data.last_name" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 25px;">
                                        <b>Mother's Name:</b>
                                        <div style="width: 88.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{lc_data.mother_first_name}} -->
                                            <input type="text" outlined dense v-model="lc_data.mother_first_name" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Nationality: </b>
                                        <div style="width: 84%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.nationality }} -->
                                            <input type="text" outlined dense v-model="lc_data.nationality" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Mother Tongue: </b>
                                        <div style="width: 76.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.mothertoungue }} -->
                                            <input type="text" outlined dense v-model="lc_data.mothertoungue" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Religion: </b>
                                        <div style="width: 80%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.religion }} -->
                                            <input type="text" outlined dense v-model="lc_data.religion" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Cast: </b>
                                        <div style="width: 89.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.caste }} -->
                                            <input type="text" outlined dense v-model="lc_data.caste" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-4" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Subcast: </b>
                                        <div style="width: 76.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.subcaste }} -->
                                            <input type="text" outlined dense v-model="lc_data.subcaste" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Place Of Birth: </b>
                                        <div style="width: 60%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.subcaste }} -->
                                            <input type="text" outlined dense v-model="lc_data.birth_place" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Tal: </b>
                                        <div style="width: 76.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.subcaste }} -->
                                            <input type="text" outlined dense v-model="lc_data.birth_taluka" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Dist: </b>
                                        <div style="width: 76.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.subcaste }} -->
                                            <input type="text" outlined dense v-model="lc_data.birth_district" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>State: </b>
                                        <div style="width: 74.5%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.subcaste }} -->
                                            <input type="text" outlined dense v-model="lc_data.birth_state" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Country: </b>
                                        <div style="width: 67%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.subcaste }} -->
                                            <input type="text" outlined dense v-model="lc_data.birth_country" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Date of Birth (in figure):</b>
                                        <span style="margin-left: 20px;">
                                            <input type="date" outlined dense v-model="lc_data.dob_fig" />
                                            ({{ lc_data.dob_fig }})
                                        </span>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Date of Birth (in words):</b>
                                        <div style="width: 84%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.dob_words }} -->
                                            <input type="text" outlined dense v-model="lc_data.dob_words" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Last School Attended:</b>
                                        <div style="width: 85%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.last_school }} -->
                                            <input type="text" outlined dense v-model="lc_data.last_school" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b> Date of Admission: </b>
                                        <div style="width: 77%; margin-left: 5px;" class="stud_details2">
                                            <input type="date" outlined dense v-model="lc_data.doa" />
                                            ({{lc_data.doa}})
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Class: </b>
                                        <div style="width: 87%; margin-left: 5px;" class="stud_details2">
                                            <input type="text" outlined dense v-model="lc_data.admittedstandard" />
                                            <!-- {{lc_data.admittedstandard}} -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b> Progress: </b>
                                        <div style="width: 88%; margin-left: 5px;" class="">
                                            <!-- {{lc_data.progress}} -->
                                            <v-combobox v-model="lc_data.progress" rounded :items="dvt_prog"
                                                label="Select Progress" outlined dense persistent-hint></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Conduct: </b>
                                        <div style="width: 84.5%; margin-left: 5px;" class="">
                                            <!-- {{lc_data.conduct}} -->
                                            <v-combobox v-model="lc_data.conduct" rounded :items="dvt_conduct"
                                                label="Select Conduct" outlined dense persistent-hint></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Date Of Leaving School:</b>
                                        <span style="margin-left: 20px;">
                                            <input type="date" outlined dense v-model="lc_data.last_date_of_school" />
                                            ({{ lc_data.last_date_of_school }})
                                        </span>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Standard in which studying and since when(in figures):</b>
                                        <div style="width: 67%; margin-left: 5px;" class="stud_details2">
                                            <!-- {{ lc_data.standard }}  -->
                                            <input type="text" outlined dense v-model="lc_data.standard" />
                                            <input type="text" outlined dense v-model="lc_data.standard_since_when" />
                                            <!-- {{ lc_data.standard_since_when }} -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Reason of Leaving School:</b>
                                        <div style="width: 50%; margin-left: 5px;" class="">
                                            <!-- {{ lc_data.reason }} -->
                                            <v-combobox v-model="lc_data.reason" rounded :items="dvt_reason"
                                                label="Select Reason" outlined dense persistent-hint></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Remark:</b>
                                        <div style="width: 50%; margin-left: 5px;" class="">
                                            <!-- {{ lc_data.remark }} -->
                                            <v-combobox v-model="lc_data.remark" rounded :items="dvt_remark"
                                                label="Select Remark" outlined dense persistent-hint></v-combobox>
                                        </div>
                                    </div>
                                </div>
                                <span class="b2-span" style="margin-left: 2%;">Certified that the above information is
                                    in accordance with School General Register. </span><br />
                            </div>
                            <div class="row">
                                <div class="col-3" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b>Dated: </b>
                                    </div>
                                </div>
                                <div class="col-3" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b> Month: </b>
                                    </div>
                                </div>
                                <div class="col-3" style="">
                                    <div class="row" style="margin-left: 20px;">
                                        <b> Year: </b>
                                    </div>
                                </div>
                            </div>
                            <v-col cols="12" style="font-weight: bolder;">
                                <v-row dense>
                                    <v-col cols="12" md="4" sm="4"><span class="b2-span ml-1">Class Teacher</span>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="4">
                                        <center><span class="b2-span">Clerk</span></center>
                                    </v-col>
                                    <v-col cols="12" md="4" sm="4">
                                        <center>
                                            <span class="b2-span">Headmistress Sign</span> <br />
                                            <!-- <span class="b2-span"> {{ org_basic_data.school_name }}</span> -->
                                        </center>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <div class="row" style="line-height: 1.2rem;">
                                <div class="col-1 ml-none" style="margin-left: 20px;">Note:</div>
                                <div class="col-10">
                                    <span>1) Any changes in school leaving certificate should carried out in red ink
                                        with the initiation of the Headmistress</span>
                                    <br />
                                    <span>2) Any infringenment of this rule is liable to rustication or other suitable
                                        punishment.</span>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
                <center>
                    <v-btn @click="proceed" class="info">Proceed to print</v-btn>
                </center>
            </div>
        </template>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                mark_inactive: false,
                headers_1: [
                    { text: "Academic Year", value: "ay" },
                    { text: "Paid", value: "paid" },
                    { text: "Balance", value: "balance" },
                    { text: "Status", value: "status" },
                ],
                headers_2: [
                    { text: "Academic Year", value: "ay" },
                    { text: "Roll No", value: "rollno" },
                    { text: "Div", value: "div" },
                    { text: "Std", value: "std" },
                    { text: "Total", value: "total" },
                    { text: "Present ", value: "present" },
                ],
                cert_no: null,
                comp_load: false,
                fetch_loader: false,
                overlay: false,
                snackbar: false,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                registration_no: null,
                stud_list: [],
                ay_record: [],
                ay_record_div: [],

                // extraBreadcrumbItems: [
                   

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                account_status: false,
                dvt_prog: [],
                progress: null,
                dvt_conduct: [],
                conduct: null,
                dvt_reason: [],
                reason: null,
                dvt_remark: [],
                remark: null,
                fetch_gen_toggle: "FETCH",
                //////date
                last_date_of_school: "",
                date_of_generation: "",
                application_date: "",
                issue_date: "",
                date: new Date().toISOString().substr(0, 10),
                gen_date: new Date().toISOString().substr(0, 10),
                date_of_application: new Date().toISOString().substr(0, 10),
                date_of_issue: new Date().toISOString().substr(0, 10),
                menu1: false,
                menu2: false,
                menu3: false,
                nowDate: new Date().toISOString().slice(0, 10),
                ///
                lc_data: null,
                org_basic_data: null,
                whether_failed_remarks: [],
                whether_failed_remark: "",
                other_activities: [],
                other_activity: "",
                extra_curricular_activities: [],
                extra_curricular_activity: "",
                any_other_remark: "",
                standard_list: [],
                promoted_standard: "",
                is_promoted_to_standard: [
                    { name: "Yes", id: "1" },
                    { name: "No", id: "2" },
                ],
                is_promoted_to_next_standard: "",
                show_promoted_standards: false,
                promoted_standard_in_words: "",
                whether_ncc_cadet: "",
                Whether_failed_in_same_class: "",
            };
        },
        watch: {
            gen_date(val) {
                this.date_of_generation = this.formatDate(this.gen_date);
            },
            date(val) {
                this.last_date_of_school = this.formatDate(this.date);
            },
            date_of_application(val) {
                this.application_date = this.formatDate(this.date_of_application);
                this.lc_data.date_of_application = this.application_date;
            },
            date_of_issue(val) {
                this.issue_date = this.formatDate(this.date_of_issue);
            },
        },
        methods: {
            proceed() {
                axios
                    .post("/certificate/saveUpdateLCData", this.lc_data)
                    .then((res) => {
                        console.log("res");
                        if (res.data.flag == "YES") {
                            localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
                            localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
                            let routeData = this.$router.resolve({ name: "wws-lc-print" });
                            window.open(routeData.href, "_blank");
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.onerror(error);
                        
                    })
                    .finally(() => {
                       
                    });
               
            },

            setToText() {
                this.lc_data.date_of_application = this.application_date;
            },

            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}-${month}-${year}`;
            },

            getColor(status) {
                if (status === "pending") return "red";
                if (status === "clear") return "green";
                if (status === "NA") return "gray";
            },

            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },

            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            onload() {
                this.ay_record = [];
                this.lc_data = null;
                this.org_basic_data = null;
                this.comp_load = true;
                axios
                    .post("/admission/getAllStudents")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_list = res.data.all_stud_list;
                        } else {
                            this.showSnackbar("red", "Something went wrong.");
                        }
                        this.comp_load = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.comp_load = false;
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            checkHistory() {
                console.log("registration_no:", this.registration_no);
                this.ay_record = [];
                this.lc_data = null;
                this.org_basic_data = null;
                if (this.registration_no == null) {
                    this.showSnackbar("red", "Please select student");
                }
                this.overlay = true;
                axios
                    .post("/certificate/checkHistory", this.registration_no)
                    .then((res) => {
                        console.log("res");
                        if (res.data.flag == "YES") {
                            this.ay_record = res.data.ay_record;
                            this.account_status = res.data.account_status;
                            this.ay_record_div = res.data.ay_record_div;
                            this.dvt_prog = res.data.dvt_prog;
                            this.progress = this.dvt_prog[0];
                            this.dvt_conduct = res.data.dvt_conduct;
                            this.conduct = this.dvt_conduct[0];
                            this.dvt_reason = res.data.dvt_reason;
                            this.reason = this.dvt_reason[0];
                            this.dvt_remark = res.data.dvt_remark;
                            this.remark = this.dvt_remark[0];

                            this.fetch_gen_toggle = res.data.fetch_gen;
                            if (this.fetch_gen_toggle == "Fetch") {
                                this.lc_data = res.data.lc_data;
                                this.org_basic_data = res.data.org_basic_data;
                            }
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.onerror(error);
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            genLC() {
                if (this.account_status == false) {
                    if (!confirm("Are You Sure You Want To Generate LC As Fees Is Pending...?")) return;
                }
                if (
                    this.progress != null &&
                    this.conduct != null &&
                    // this.last_date_of_school != "" &&
                    this.remark != null &&
                    this.reason != null &&
                    this.cert_no != null &&
                    this.date_of_generation != null &&
                    this.application_date != null &&
                    this.issue_date != null
                ) {
                    const formData = {
                        lid: this.registration_no.lid,
                        progress: this.progress,
                        conduct: this.conduct,
                        remark: this.remark,
                        reason: this.reason,
                        reason: this.reason,
                        cert_no: this.cert_no,
                        // last_date_of_school: this.last_date_of_school,
                        gen_date: this.date_of_generation,
                        date_of_application: this.application_date,
                        date_of_issue: this.issue_date,
                    };
                    this.overlay = true;
                    axios
                        .post("/certificate/genLC", formData)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.org_basic_data = res.data.org_basic_data;
                                this.lc_data = res.data.lc_data;
                                this.lc_data.last_school = this.org_basic_data.school_name;
                                this.fetch_gen_toggle = "Fetch";
                                this.showSnackbar("green", "Success..!!!");
                            } else {
                                this.showSnackbar("red", res.data.snackbar);
                                sessionStorage.setItem("error-trace", res.data.error_trace);
                            }
                            this.overlay = false;
                        })
                        .catch((error) => {
                            this.onerror(error);

                            this.overlay = false;
                        })
                        .finally(() => {
                            this.overlay = false;
                        });
                } else {
                    this.showSnackbar("red", "Please select/enter all data");
                }
            },
        },
        mounted() {
            this.onload();
            this.last_date_of_school = this.formatDate(this.date);
            this.date_of_generation = this.formatDate(this.gen_date);
            this.application_date = this.formatDate(this.date_of_application);
            this.issue_date = this.formatDate(this.date_of_issue);
        },
    };
</script>
<style scoped>
    .scroll {
        overflow-x: scroll;
    }

    .mytable1 /deep/ thead th {
        background: #0f2027 !important;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }

    .mytable /deep/ thead th {
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
        background: #83a4d4;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #265fb1, #b6fbff);
        /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #265fb1, #b6fbff);
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }

    /* tr,
td,
th {
border: 1px solid #ccc;
text-align: center;
font-size: small;
}
tr,
tbody {
border-bottom: 1px solid #ccc;
border: 1px solid #ccc;
font-size: small;
}
td {
margin: 0.3rem !important;
padding: 0.4rem !important;
font-size: small;
} */
    /* @media (min-width: 320px) {
td,
th {
display: table-cell !important;
font-size: small;
}
td + td,
th + th {
width: auto;
font-size: small;
}
} */
    /* v-simple-table {
white-space: nowrap !important;
text-align: center;
font-size: medium;
} */

    .expapanel {
        width: 93%;
        margin-left: 3%;
    }

    .panelheader {
        /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
        color: white !important;
        background: #83a4d4;
        /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
        /* Chrome 10-25, Safari 5.1-6 */
        /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        font-size: 16px;
        background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
    }

    .fees span {
        font-size: 23px;
        font-weight: 600;
    }

    /* .radiobtn{
display: inline !important;
} */

    /* lc data css */
    .printdiv {
        border: 3px solid;
        border-color: black;
        height: auto;
        /* width: 944px; */
        /* margin-left: 5%; */
        /* margin-top: 5px; */
        width: auto;
        margin-left: 5%;
        margin-right: 5%;
    }

    .header {
        /* border:2px solid;  */
        margin: 6px;
    }

    .trust-name {
        /* margin-left: 22%; */
        text-transform: uppercase;
        font-size: x-large;
    }

    .schl-name {
        font-size: 30px;
        text-transform: uppercase;
        font-size: xxx-large;
    }

    .adrs {
        margin-left: 33px;
        font-size: larger;
        font-weight: 500;
    }

    /* .line1 {
margin-left: 15px;
}
.line2 {
margin-left: 22px;
} */

    .stdsection {
        margin-left: 30%;
        font-weight: bold;
        text-transform: uppercase;
        font-size: 15px;
    }

    .b-sapn {
        display: block;
        margin-top: 2px;
    }

    .lcheading {
        /* border-block: 1px solid black; */
        border: 1px solid black;

        /* display: block; */
        /* width: 26%; */
        /* border-left: 1px solid black; */
        /* border-right: 1px solid black; */
        /* margin-left: 30%; */
        font-size: 17px;
        font-weight: 600;
        padding-left: 5px;
        padding-right: 5px;
        text-transform: uppercase;
    }

    .lcheading1 {
        margin-left: 16%;
        width: 65%;
        /* text-align: center; */
        border-radius: 17px;
        border: 1px solid black;
    }

    .lcheading1 h3 {
        font-size: xx-large;
        margin-left: 18px;
        font-family: Segoe Print;
        font-style: italic;
    }

    .schlImg {
        /* width: 196px;
height: 196px; */
        width: 50%;
        height: 90%;
        margin-left: 10px;
    }

    .tdata2 {
        font-weight: bolder;
    }

    #page tr,
    td {
        /* padding: 0;  */
        /* margin-left: 0px; */
        font-size: medium;
        text-align: left;
    }

    /* lc data css end */

    /* print lc css */
    @media print {
        .card {
            border: none !important;
            font-size: large !important;
        }

        .pagebreak {
            page-break-before: always;
        }

        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
        }

        /* img {
width: 100% !important;
} */
        body,
        tr,
        th,
        td {
            font-size: large !important;
        }

        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }

        v-card {
            border: none !important;
        }

        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 13.5in 20.5in;

            /* size: 13in 18in; */
        }

        thead {
            font-weight: bold !important;
        }

        table,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }

    /* print lc css end */
    .redrow {
        background-color: red !important;
        color: red;
    }

    .style-1 {
        background-color: rgb(215, 84, 44);
        font-weight: bolder;
    }

    .style-2 {
        background-color: rgb(61, 219, 21);
    }

    span.stretch {
        display: inline-block;
        -webkit-transform: scale(1.5, 1);
        /* Safari and Chrome */
        -moz-transform: scale(1.3, 1);
        /* Firefox */
        -ms-transform: scale(1.5, 1);
        /* IE 9 */
        -o-transform: scale(1.5, 1);
        /* Opera */
        /* transform: scale(1.3,1); */
        /* margin-left: 25%; */
        font-size: 14px;
    }

    .stretch1 {
        display: inline-block;
        -webkit-transform: scale(1.3, 1);
        /* Safari and Chrome */
        -moz-transform: scale(1.3, 1);
        /* Firefox */
        -ms-transform: scale(1.5, 1);
        /* IE 9 */
        -o-transform: scale(1.5, 1);
        /* Opera */
        /* transform: scale(1.3,1); */
        /* margin-left: 25%; */
        font-size: 14px;
    }
    .stud_details2 {
        border-bottom: 1px solid black;
    }
    .hr-tag {
        height: 1px;
        border-width: 0px;
        color: black;
        background-color: black;
        width: 98%;
        margin-left: 10px;
        margin-bottom: 4px;
    }
    div.row {
        margin-top: -5px;
    }
</style>
